import { CompassIcon as PhosphorCompassIcon } from "@phosphor-icons/react/dist/ssr/Compass";

import { createAppIcon } from "@/components/createAppIcon";

export const ExploreIcon = /* @__PURE__ */ createAppIcon(PhosphorCompassIcon);
